<template>
  <div class="share-container">
    <div class="share-header">
      <div class="header-content">
        <button @click.stop="goBack" class="back-button">
          <span class="back-icon">←</span>
          <span>返回</span>
        </button>
        <div class="header-title">
          <div class="title-icon">🧹</div>
          <h1>清理素材</h1>
        </div>
      </div>
    </div>

    <div class="share-content">
      <div class="current-shop-section" v-if="advertiserName">
        <div class="shop-info-container">
          <div class="shop-icon">🏪</div>
          <div class="shop-details">
            <h3 class="shop-name">当前授权店铺</h3>
            <p class="shop-advertiser">{{ advertiserName }}</p>
          </div>
        </div>
      </div>

      <div class="form-card">
        <div class="form-title-row">
          <h2 class="form-title">待清理账户信息</h2>
          <button type="button" class="manual-input-toggle" @click="toggleManualInputMode">
            {{ isManualInputMode ? '关闭手动输入' : '手动输入' }}
          </button>
        </div>
        <div class="form-grid">
          <div class="input-group">
            <label for="old-advertiser-id">千川户ID</label>
            <input
              v-if="isManualInputMode"
              id="old-advertiser-id"
              v-model.trim="oldAdvertiserId"
              type="text"
              placeholder="请输入待清理千川户ID"
            />
            <el-select
              v-else
              id="old-advertiser-id"
              v-model="oldAdvertiserId"
              filterable
              placeholder="请选择待清理千川户"
              class="input-group-select"
              :disabled="advertiserLoading"
              :popper-append-to-body="true"
              @change="onOldAdvertiserChange"
            >
              <el-option v-for="item in advertiserOptions" :key="`old-${item.advertiserId}`" :label="item.name" :value="item.advertiserId" />
            </el-select>
          </div>
          <div class="input-group">
            <label for="old-ad-id">计划ID</label>
            <input
              v-if="isManualInputMode"
              id="old-ad-id"
              v-model.trim="oldAdId"
              type="text"
              placeholder="请输入待清理计划ID"
            />
            <el-select
              v-else
              id="old-ad-id"
              v-model="oldAdId"
              filterable
              placeholder="请选择待清理计划ID"
              class="input-group-select"
              :disabled="oldJobLoading || !oldAdvertiserId"
              :popper-append-to-body="true"
            >
              <el-option v-for="item in oldJobOptions" :key="`old-job-${item.id}`" :label="item.name" :value="item.id" />
            </el-select>
          </div>
        </div>
      </div>

      <div class="action-section">
        <button class="share-submit-button" @click="submitCleanup" :disabled="isCleaning">
          <span v-if="isCleaning" class="button-spinner"></span>
          <span>{{ isCleaning ? cleaningText : '清理素材' }}</span>
        </button>
      </div>

      <div v-if="statusMessage" class="status-message" :class="{ success: statusType === 'success', error: statusType === 'error' }">
        {{ statusMessage }}
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import API_CONFIG from '@/api/config'
import { createAdaptiveViewportMixin } from '@/mixins/adaptiveViewport'

export default {
  name: 'MaterialCleanup',
  mixins: [createAdaptiveViewportMixin({ designWidth: 1440, designHeight: 860, minScale: 0.6 })],
  data() {
    return {
      accessToken: '',
      advertiserName: '',
      username: '',
      advertiserOptions: [],
      advertiserLoading: false,
      oldAdvertiserId: '',
      oldAdId: '',
      oldJobOptions: [],
      oldJobLoading: false,
      isManualInputMode: false,
      isCleaning: false,
      statusMessage: '',
      statusType: '',
      cleaningDots: '',
      cleaningTimer: null
    }
  },
  computed: {
    cleaningText() {
      return `清理中${this.cleaningDots}`
    }
  },
  created() {
    const query = this.$route.query
    this.accessToken = query.accessToken || localStorage.getItem('accessToken') || ''
    this.advertiserName = query.advertiserName || localStorage.getItem('advertiserName') || ''
    this.username = query.username || localStorage.getItem('username') || ''
    this.updatePageTitle()
    if (this.accessToken) {
      this.fetchAdvertiserOptions()
    }
  },
  methods: {
    updatePageTitle() {
      const name = String(this.advertiserName || '').trim()
      document.title = name ? `${name} - 清理素材` : '清理素材'
    },
    goBack() {
      this.$router.push('/home')
    },
    toggleManualInputMode() {
      this.isManualInputMode = !this.isManualInputMode
      if (this.isManualInputMode) {
        this.oldJobOptions = []
      } else if (this.oldAdvertiserId) {
        this.onOldAdvertiserChange()
      }
    },
    startCleaningAnimation() {
      const dotStates = ['', '.', '..', '...']
      let index = 0
      this.cleaningDots = dotStates[index]
      this.cleaningTimer = setInterval(() => {
        index = (index + 1) % dotStates.length
        this.cleaningDots = dotStates[index]
      }, 400)
    },
    stopCleaningAnimation() {
      if (this.cleaningTimer) {
        clearInterval(this.cleaningTimer)
        this.cleaningTimer = null
      }
      this.cleaningDots = ''
    },
    async fetchAdvertiserOptions() {
      this.advertiserLoading = true
      try {
        const response = await axios.get(API_CONFIG.getFullUrl('/qianchuan/info/api/getShopAdvertiserPublicSimpleInfo'), {
          params: {
            accessToken: this.accessToken
          },
          headers: {
            username: this.username
          }
        })
        const list = response.data && response.data.code === 200 ? (response.data.data || []) : []
        this.advertiserOptions = list.map(item => ({
          name: item.id || '-',
          advertiserId: item.advertiser_id
        })).filter(item => item.advertiserId)
      } catch (error) {
        this.advertiserOptions = []
      } finally {
        this.advertiserLoading = false
      }
    },
    async fetchJobOptions(advertiserId) {
      if (!advertiserId) {
        return []
      }
      const response = await axios.get(API_CONFIG.uniPromotionJobListByTargetId(), {
        params: {
          targetId: advertiserId
        },
        headers: {
          username: this.username
        }
      })
      const list = response.data && response.data.code === 200 ? (response.data.data || []) : []
      return list.map(item => ({
        id: item.jobId,
        name: item.jobName || String(item.jobId || '-')
      })).filter(item => item.id)
    },
    async onOldAdvertiserChange() {
      this.oldAdId = ''
      this.oldJobOptions = []
      if (!this.oldAdvertiserId) {
        return
      }
      this.oldJobLoading = true
      try {
        this.oldJobOptions = await this.fetchJobOptions(this.oldAdvertiserId)
      } catch (error) {
        this.oldJobOptions = []
      } finally {
        this.oldJobLoading = false
      }
    },
    async submitCleanup() {
      if (!this.accessToken) {
        this.statusType = 'error'
        this.statusMessage = '缺少access_token，请返回授权页重新进入'
        return
      }
      if (!this.oldAdvertiserId || !this.oldAdId) {
        this.statusType = 'error'
        this.statusMessage = '请完整填写待清理账户信息'
        return
      }
      const numericPattern = /^\d+$/
      if (![this.oldAdvertiserId, this.oldAdId].every(value => numericPattern.test(String(value)))) {
        this.statusType = 'error'
        this.statusMessage = '千川户ID、计划ID必须为数字'
        return
      }

      this.isCleaning = true
      this.statusMessage = ''
      this.statusType = ''
      this.startCleaningAnimation()

      try {
        const payload = {
          advertiser_id: Number(this.oldAdvertiserId),
          ad_id: Number(this.oldAdId)
        }
        const response = await axios.post(API_CONFIG.materialDelete(), payload, {
          headers: {
            'Content-Type': 'application/json',
            username: this.username
          }
        })
        if (response.data && response.data.code === 200) {
          const result = response.data.data || {}
          const deletedCount = result.deletedCount != null ? result.deletedCount : '-'
          const roundCount = result.roundCount != null ? result.roundCount : '-'
          const message = result.message || '素材清理成功'
          this.statusType = 'success'
          this.statusMessage = `${message}（删除数量：${deletedCount}，批次数：${roundCount}）`
        } else {
          this.statusType = 'error'
          this.statusMessage = (response.data && (response.data.msg || response.data.message)) || '素材清理失败'
        }
      } catch (error) {
        this.statusType = 'error'
        this.statusMessage = error.response?.data?.msg || error.response?.data?.message || '素材清理请求失败'
      } finally {
        this.isCleaning = false
        this.stopCleaningAnimation()
      }
    }
  },
  beforeDestroy() {
    this.stopCleaningAnimation()
  }
}
</script>

<style scoped>
.share-container {
  min-height: 100vh;
  height: 100vh;
  background: linear-gradient(135deg, #2c3e50 0%, #34495e 100%);
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.share-header {
  background: rgba(255, 255, 255, 0.1);
  backdrop-filter: blur(10px);
  border-bottom: 1px solid rgba(255, 255, 255, 0.2);
  padding: 14px 0;
}

.header-content {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
  display: flex;
  align-items: center;
  gap: 20px;
}

.back-button {
  background: rgba(255, 255, 255, 0.1);
  border: 1px solid rgba(255, 255, 255, 0.3);
  border-radius: 25px;
  padding: 10px 20px;
  color: white;
  font-size: 14px;
  cursor: pointer;
  transition: all 0.3s ease;
  display: flex;
  align-items: center;
  gap: 8px;
}

.back-button:hover {
  background: rgba(255, 255, 255, 0.2);
  transform: translateX(-5px);
}

.header-title {
  display: flex;
  align-items: center;
  gap: 10px;
}

.title-icon {
  font-size: 24px;
}

.header-title h1 {
  color: white;
  font-size: 24px;
  font-weight: 600;
  margin: 0;
}

.share-content {
  flex: 1;
  width: 100%;
  max-width: 1200px;
  margin: 0 auto;
  padding: 16px 16px 18px;
  overflow: hidden;
  min-height: 0;
  box-sizing: border-box;
}

.current-shop-section {
  margin-bottom: 20px;
}

.shop-info-container {
  background: rgba(255, 255, 255, 0.12);
  backdrop-filter: blur(10px);
  border: 1px solid rgba(255, 255, 255, 0.2);
  border-radius: 12px;
  padding: 18px 20px;
  display: flex;
  align-items: center;
  gap: 12px;
}

.shop-icon {
  font-size: 24px;
}

.shop-details h3,
.shop-details p {
  margin: 0;
}

.shop-name {
  color: rgba(255, 255, 255, 0.8);
  font-size: 14px;
  font-weight: 500;
}

.shop-advertiser {
  color: white;
  font-size: 18px;
  font-weight: 600;
  margin-top: 4px;
}

.form-card {
  background: rgba(255, 255, 255, 0.12);
  backdrop-filter: blur(10px);
  border: 1px solid rgba(255, 255, 255, 0.2);
  border-radius: 15px;
  padding: 18px;
  margin-bottom: 14px;
}

.form-title {
  margin: 0 0 18px;
  color: white;
  font-size: 20px;
}

.form-title-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  margin-bottom: 18px;
}

.form-title-row .form-title {
  margin: 0;
}

.manual-input-toggle {
  border: 1px solid rgba(255, 255, 255, 0.35);
  border-radius: 999px;
  background: rgba(255, 255, 255, 0.1);
  color: #fff;
  padding: 6px 12px;
  font-size: 12px;
  cursor: pointer;
  transition: all 0.3s ease;
}

.manual-input-toggle:hover {
  background: rgba(255, 255, 255, 0.2);
}

.form-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(260px, 1fr));
  gap: 16px;
}

.input-group {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.input-group label {
  color: rgba(255, 255, 255, 0.85);
  font-size: 14px;
}

.input-group-select {
  width: 100%;
}

.input-group input {
  background: rgba(255, 255, 255, 0.12);
  border: 1px solid rgba(255, 255, 255, 0.25);
  border-radius: 10px;
  color: white;
  font-size: 14px;
  padding: 12px 14px;
  outline: none;
  transition: all 0.3s ease;
}

.input-group input::placeholder {
  color: rgba(255, 255, 255, 0.55);
}

.input-group input:focus {
  border-color: #00d4ff;
  box-shadow: 0 0 0 2px rgba(0, 212, 255, 0.18);
}

::v-deep .input-group-select .el-input__inner {
  background: rgba(255, 255, 255, 0.12);
  border: 1px solid rgba(255, 255, 255, 0.25);
  border-radius: 10px;
  color: white;
  font-size: 14px;
  height: 44px;
  line-height: 44px;
}

::v-deep .input-group-select .el-input__suffix-inner i {
  color: rgba(255, 255, 255, 0.75);
}

::v-deep .input-group-select.is-disabled .el-input__inner {
  background: rgba(255, 255, 255, 0.08);
  color: rgba(255, 255, 255, 0.55);
}

::v-deep .el-select-dropdown__item {
  color: #1f2a44;
}

.action-section {
  margin-top: 10px;
}

.share-submit-button {
  width: 100%;
  border: none;
  border-radius: 25px;
  background: linear-gradient(45deg, #20bf6b, #0fb9b1);
  color: white;
  font-size: 16px;
  font-weight: 600;
  padding: 14px 20px;
  cursor: pointer;
  transition: all 0.3s ease;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
}

.share-submit-button:disabled {
  opacity: 0.8;
  cursor: not-allowed;
}

.share-submit-button:not(:disabled):hover {
  transform: translateY(-2px);
  box-shadow: 0 8px 18px rgba(15, 185, 177, 0.35);
}

.button-spinner {
  width: 16px;
  height: 16px;
  border: 2px solid rgba(255, 255, 255, 0.35);
  border-top-color: #ffffff;
  border-radius: 50%;
  animation: spin 0.8s linear infinite;
}

.status-message {
  margin-top: 16px;
  border-radius: 10px;
  padding: 12px 14px;
  font-size: 14px;
}

.status-message.success {
  background: rgba(46, 213, 115, 0.2);
  border: 1px solid rgba(46, 213, 115, 0.4);
  color: #7dffb8;
}

.status-message.error {
  background: rgba(255, 107, 107, 0.2);
  border: 1px solid rgba(255, 107, 107, 0.4);
  color: #ff9f9f;
}

@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}
</style>
